import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';

import Header from './components/common/Header'
import Spinner from './components/common/Spinner';
import DiscoverList from './components/discoverUs/DiscoverList';
import FindParksNearMe from './components/common/FindParksNearMe';
import GeoCode from './components/common/GeoCode';


const Footer = lazy(() => import('./components/common/Footer')); 



function App() {
  return (
    <Router basename="/pgparks/discoverUs">
    <div className="container-fluid">
      <Header />
      <Suspense fallback={<Spinner/>}>
      <Routes>
        <Route path="/" element={<DiscoverList/>} />
        <Route path="/nearby" element={<FindParksNearMe/>} />
        <Route path="/geocode" element={<GeoCode/>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
    <Suspense fallback={<div> Loding Footer...</div>}>
   <Footer />
   </Suspense>
    </div>
     </Router>
  );
}

export default App;
